import React, { useState } from 'react';
import { Button, Modal } from 'antd';

import colors from '../../constants/Colors';

import { safeExtractFromObject } from '../../helpers/helpers';

import store from '../../state/store';

const getButton = (color, disabled) => ({
  backgroundColor: color,
  borderColor: color,
  color: 'white',
  borderRadius: 18,
  width: 110,
  height: 36,
  opacity: disabled ? 0.5 : 1,
});

function ConfirmThirdButtons({
  cancelText,
  okText,
  thirdText,
  onCancel,
  onOk,
  onThirdButtonClick,
  cancelButtonStyle,
  okButtonStyle,
  closeModal,
}) {
  const [thirdLoading, setThirdLoading] = useState(false);

  const onBack = () => {
    if (onCancel) onCancel();
    closeModal();
  };

  const onContinue = async () => {
    if (onOk) await onOk();
    closeModal();
  };

  const onClose = async () => {
    setThirdLoading(true);
    try {
      const result = await onThirdButtonClick();
      if (result === false) {
        setThirdLoading(false);
        return;
      }
      closeModal();
    } catch {
      setThirdLoading(false);
    }
  };

  const dimmed = (style) => ({
    ...style,
    ...(thirdLoading ? { opacity: 0.5 } : {}),
  });

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 8,
        width: '100%',
        marginTop: 24,
      }}
    >
      <Button
        style={dimmed(cancelButtonStyle)}
        onClick={onBack}
        disabled={thirdLoading}
      >
        {cancelText}
      </Button>
      <Button
        type="primary"
        style={dimmed(okButtonStyle)}
        onClick={onContinue}
        disabled={thirdLoading}
      >
        {okText}
      </Button>
      <Button
        type="primary"
        style={okButtonStyle}
        onClick={onClose}
        loading={thirdLoading}
      >
        {thirdText}
      </Button>
    </div>
  );
}

const { confirm } = Modal;
export default ({
  title,
  onOk,
  okText,
  onCancel,
  cancelText,
  style,
  content,
  hideFooter = false,
  hideCancel = false,
  afterClose = () => {},
  maskColor,
  maskClosable = true,
  keyboard = true,
  okButtonDisabled = false,
  okButtonStyle = {},
  cancelButtonStyle = {},
  additionalOptions = {},
  zIndex = 1000,
  thirdText,
  onThirdButtonClick,
}) => {
  const state = store.getState();
  const hasRedesign = safeExtractFromObject(state, 'settings.company.settings.uxRedesignPt1');

  const options = {
    ...style,
    maskClosable,
    keyboard,
    wrapClassName: 'myModal',
    title,
    content,
    onCancel,
    cancelText,
    onOk,
    okText,
    centered: true,
    zIndex,
    okButtonProps: {
      style: {
        ...getButton(hasRedesign ? colors.BLUE_700 : colors.ONTRACCR_RED, okButtonDisabled),
        ...hasRedesign ? {
          fontFamily: 'open-sans-600, sans-serif',
        } : {},
        ...okButtonStyle,
      },
      disabled: okButtonDisabled,
    },
    cancelButtonProps: {
      style: {
        ...getButton('gray'),
        ...hasRedesign ? {
          backgroundColor: 'white',
          color: colors.REDESIGN_BUTTON_UNSELECTED_TEXT,
          borderColor: colors.GRAY_400,
          fontFamily: 'open-sans-600, sans-serif',
        } : {},
        ...cancelButtonStyle,
      },
    },
    afterClose,
    ...additionalOptions,
  };
  if (hideCancel) options.cancelButtonProps = { style: { display: 'none' }, className: 'modal-footer-hidden-button' };
  if (hideFooter) {
    options.okButtonProps = { style: { display: 'none' }, className: 'modal-footer-hidden-button' };
    options.cancelButtonProps = { style: { display: 'none' }, className: 'modal-footer-hidden-button' };
  }

  if (maskColor) {
    options.maskStyle = {
      backgroundColor: maskColor,
    };
  }

  const resolvedOkStyle = options.okButtonProps?.style;
  const resolvedCancelStyle = options.cancelButtonProps?.style;
  let modal;
  // If there is a third button, show the confirm third button component.
  if (thirdText) {
    options.wrapClassName = `${options.wrapClassName || ''} confirm-third-button`.trim();
    // Hide the default ok and cancel buttons.
    options.okButtonProps = {
      style: { display: 'none' },
      className: 'modal-footer-hidden-button',
    };
    options.cancelButtonProps = {
      style: { display: 'none' },
      className: 'modal-footer-hidden-button',
    };
    options.content = (
      <>
        {content}
        <ConfirmThirdButtons
          cancelText={cancelText}
          okText={okText}
          thirdText={thirdText}
          onCancel={onCancel}
          onOk={onOk}
          onThirdButtonClick={onThirdButtonClick}
          cancelButtonStyle={resolvedCancelStyle}
          okButtonStyle={resolvedOkStyle}
          closeModal={() => modal?.destroy()}
        />
      </>
    );
  }

  modal = confirm(options);
  return modal;
};
